module.exports = __webpack_public_path__ + "img/background_gfa.6421c34e.jpg";